<style lang="scss" src='./ProvisioningStep1.scss' scoped ></style>
<template src="./ProvisioningStep1.html"></template>

<script>
import { mapMutations, mapState } from 'vuex';
import { GetHoles, GetZones, GetSoilTypes  } from '@/api/api';
import MapBlueFlag from '@/assets/img/gw/flags/ic_flag_blue.png';

export default {
  name: 'ProvisioningStep1',
  data() {
    return ({
      sensor: {},
      holes: [],
      zones: [],
      grassTypes: [],
      soilTypes: [],
      location: {
        hole: null,
        zone: null,
        teeMarker: null,
        location: null,
        quadrant: null,
        location_note: null,
        grassType: null,
        soilType: null,
      },
      map: {},
      loadingMap: false,
    });
  },
  computed: {
    ...mapState(['course']), 

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },

    zonesFiltered: function zonesFilteredFn() {
      if (this.zones && this.zones.length && this.location.hole && this.checkCourseType()) {
        const holeLinked = this.location.hole.hole_id;
        return this.zones.filter((zone) => (holeLinked ? zone.hole_linked : !zone.hole_linked));
      }else if(!this.checkCourseType()) {
        return this.zones;
      }
      return [];
    },

    validLatLong(){
      if(this.sensor && this.sensor.latitude && this.sensor.longitude){
        if(!this.loadingMap){
          this.loadingMap = true;
          this.initMap({ lat: this.sensor.latitude, lng: this.sensor.longitude });
        }
        return true;
      }else{
        this.loadingMap = false;
        return false;
      }
    },

    getGrassTypeLabel() {
      if(this.checkCourseType() && this.location && this.location.zone && this.location.zone.code === 'GB'){
        return this.$t('sensors.provisionSelectGrassTypeGroundCover');
      }
      return this.$t('sensors.provisionSelectGrassType');

    },

    getSoilTypeLabel() {
      return this.$t('sensors.provisionSelectSoilType');

    },
  },

  methods: {
    checkCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },

    loadHoles() {
      GetHoles().then((data) => {
        this.holes = data.holes;
      });
    },

    loadZones() {
      GetZones().then((data) => {
        this.zones = data.zones.filter(x => !x.hidden);
        this.grassTypes = data.grass_types
      });
    },

    loadSoilTypes() {
      GetSoilTypes().then((data) => {
        this.soilTypes = data.soil_types
      });
    },

    onChangeHole() {
      this.location.zone = null;
      this.setHole(this.location.hole);
    },
    onChangeZone() {
      this.location.teeMarker = null;
      this.location.location = null;
      this.location.quadrant = null;
      this.location.grassType = null;
      this.location.soilType = null;
    },

    addValToProvisionPayload(payload, obj, id) {
      if (obj != null) {
        payload[id] = obj[id] ? obj[id] : null;
      }
    },

    getLocationDesc() {
      let desc = '';
      if (this.checkCourseType()) {
        if (this.location.hole.hole_id) {
          const holeNumber = this.location.hole.hole_number;
          desc += (`${this.G_getOrdinalSuffix(holeNumber)}`);
        } else {
          desc += `${this.$t('general.other')}`;
        }
        desc += `, ${this.location.zone.name.toLowerCase()}`;

        if (this.location.teeMarker) {
          desc += `, ${this.location.teeMarker.name.toLowerCase()}`;
        }
        if (this.location.location) {
          desc += `, ${this.location.location.name.toLowerCase()}`;
        }
        if (this.location.quadrant) {
          desc += `, ${this.location.quadrant.quadrant} ${this.$t('sensors.yardageOutFromGreen')}`;
        }
        return desc;
      } else {
        return `${this.location.location}`
      }
    },

    getLocationCode() {
      let code = '';
      if(this.checkCourseType()){
        if (this.location.hole.hole_id) {
          const holeNumber = this.location.hole.hole_number;
          code += `${holeNumber}`;
        } else {
          code += 'O';
        }
  
        code += `${this.location.zone.code}`;
  
        if (this.location.teeMarker) {
          code += `${this.location.teeMarker.code}`;
        }
        if (this.location.location) {
          code += `${this.location.location.code}`;
        }
        if (this.location.quadrant) {
          code += `${this.location.quadrant.quadrant}`;
        }
      } else if(!this.checkCourseType()) {
        code = `${this.location.hole.hole_number}`
      }
      return code;
    },

    async continue() {
      const valid = await this.validateForm();
      if (valid) {
        if(this.checkCourseType()) { 
          const provisionPayload = {};
          this.addValToProvisionPayload(provisionPayload, this.location.hole, 'hole_id');
          this.addValToProvisionPayload(provisionPayload, this.location.zone, 'zone_id');
          this.addValToProvisionPayload(provisionPayload, this.location.teeMarker, 'tee_marker_id');
          this.addValToProvisionPayload(provisionPayload, this.location.grassType, 'grass_type_id');
          this.addValToProvisionPayload(provisionPayload, this.location.soilType, 'soil_type_id');
          this.addValToProvisionPayload(provisionPayload, this.location.location, 'location_id');
          this.addValToProvisionPayload(provisionPayload, this.location.quadrant, 'quadrant_id');
          provisionPayload.location_desc = this.getLocationDesc();
          provisionPayload.location_code = this.getLocationCode();
          provisionPayload.location_note = this.location.location_note;
  
          this.setProvisionPayload(provisionPayload);
        } else if(!this.checkCourseType()) {
          const provisionPayload = {};
  
          provisionPayload.hole_id      = this.location.hole.hole_id;
          provisionPayload.zone_id      = null;
          this.addValToProvisionPayload(provisionPayload, this.location.grassType, 'grass_type_id');
          this.addValToProvisionPayload(provisionPayload, this.location.soilType, 'soil_type_id');
          provisionPayload.location_desc = this.getLocationDesc();
          provisionPayload.location_code = this.getLocationCode();
          provisionPayload.location_note = this.location.location_note;
          this.setProvisionPayload(provisionPayload);
        }
      }

      return valid;
    },

    async validateForm() {
      const valid = await this.$refs.validator.validate().then((v) => v);
      return valid;
    },

    async initMap({ lat = 0, lng = 0 }) {
      const mapOptions = {
        mapId: 'map',
        zoom: 18,
        center: { lat, lng },
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };

      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;

      const newMark = new window.google.maps.Marker({
        position: { lat, lng },
        icon: MapBlueFlag,
      });
      newMark.setMap(this.map);
    },

    ...mapMutations('SensorProvisioning', ['setCanBack', 'setCanContinue', 'setProvisionPayload', 'setHole']),
  },

  beforeCreate() {},

  created() {},

  activated() {
    this.loadingMap = false;
    this.setCanContinue(this.continue);
    this.setCanBack(null);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
    this.loadHoles();
    this.loadZones();
    this.loadSoilTypes();
  },
};
</script>
